import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Pagination, useMediaQuery, useTheme } from '@mui/material';
import { useContext, useEffect, useState } from "react";
import { LoginContext } from '../contexts/LoginContext';
import getTransactionService from '../services/Transaction/getTransactionService';
import styles from '../styles/OwnTestCreation.module.css';

const TransactionPage = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [pageState, setPageState] = useState({ page: 1, pageSize: 10 });
    const [sortBy, setSortBy] = useState('startDate');
    const [sortOrder, setSortOrder] = useState('desc');
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);

    const { UserId, showSubscriptionData } = useContext(LoginContext);

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            const resp = await getTransactionService.getTransactionData(UserId);
            setTransactions(resp?.$values);
            if (resp?.status === 200) {
                //setDialogOpen(false)
            }
            setLoading(false);
        }
        fetchData();
    }, [])

    const convertToLocalTime = (utcDateTime) => {
        const date = new Date(utcDateTime);
        const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        const hours = String(localDate.getHours()).padStart(2, '0');
        const minutes = String(localDate.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    }
    const handleSort = (field) => {
        const isAsc = sortBy === field && sortOrder === 'asc';
        setSortBy(field);
        setSortOrder(isAsc ? 'desc' : 'asc');
    };

    const handleChange = (event, value) => {
        setPageState((prev) => ({ ...prev, page: value }));
    };

    const sortedData = [...transactions].sort((a, b) => {
        if (a[sortBy] < b[sortBy]) return sortOrder === 'asc' ? -1 : 1;
        if (a[sortBy] > b[sortBy]) return sortOrder === 'asc' ? 1 : -1;
        return 0;
    });

    const paginatedData = sortedData.slice(
        (pageState.page - 1) * pageState.pageSize,
        pageState.page * pageState.pageSize
    );

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        fontFamily: 'Poppins',
        fontSize: '16px',
        border: '1px solid lightgray'
    };

    // const cellStyle = {
    //     borderBottom: '0.5px solid #dddddd',
    //     padding: '8px 2%',
    // };
    const cellStyle = {
        borderBottom: '0.5px solid #dddddd',
        padding: '8px 2%',
        wordWrap: 'break-word',
        whiteSpace: 'nowrap',
    };

    const evenRowStyle = {
        backgroundColor: '#f9f9f9',
    };

    return (
        <div style={{ overflowX: 'auto' }}>

            {loading ?
                <div style={{ justifyContent: 'Center' }}>
                    {"Loading..."}
                </div>
                : (
                    isMobile ?
                        (
                            <div>
                                {paginatedData.map((tx, index) => (
                                    <div key={index} style={{ textAlign: 'left', border: '1px solid #ccc', marginBottom: '1rem', borderRadius: 8, padding: '1rem', backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
                                        <div><strong>Transaction ID:</strong> {tx.transactionId}</div>
                                        <div><strong>Start Date:</strong> {convertToLocalTime(tx.startDate)}</div>
                                        <div><strong>End Date:</strong> {convertToLocalTime(tx.endDate)}</div>
                                        <div><strong>Subscription:</strong> {tx.subscriptionName}</div>
                                        <div><strong>Tests:</strong> {tx.numberOfTests}</div>
                                        <div><strong>Remaining:</strong> {
                                            showSubscriptionData?.userSubscriptionId === tx?.userSubscriptionId
                                                ? Math.max(
                                                    transactions.reduce((sum, tx) => sum + (tx?.numberOfTests || 0), 0) -
                                                    transactions.reduce((sum, tx) => sum + (tx?.assignedTestsCount || 0), 0),
                                                    0
                                                )
                                                : '-'
                                        }</div>
                                        <div><strong>Amount:</strong> ₹{tx.price?.toFixed(2)}</div>
                                    </div>
                                ))}
                            </div>
                        ) :
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th
                                        className={`${styles.HeadLeft} ${styles.codeColumn}`}
                                        style={{ ...cellStyle, color: theme.palette.sectionHeading.main, cursor: 'pointer' }}
                                        onClick={() => handleSort('transactionId')}
                                    >
                                        Transaction ID {sortBy === 'transactionId' && (sortOrder === 'asc' ? <ArrowUpward fontSize="inherit" /> : <ArrowDownward fontSize="inherit" />)}
                                    </th>

                                    <th
                                        className={styles.HeadLeft}
                                        style={{ ...cellStyle, color: theme.palette.sectionHeading.main, cursor: 'pointer' }}
                                        onClick={() => handleSort('startDate')}
                                    >
                                        Start Date {sortBy === 'startDate' && (sortOrder === 'asc' ? <ArrowUpward fontSize="inherit" /> : <ArrowDownward fontSize="inherit" />)}
                                    </th>

                                    <th
                                        className={styles.HeadLeft}
                                        style={{ ...cellStyle, color: theme.palette.sectionHeading.main, cursor: 'pointer' }}
                                        onClick={() => handleSort('endDate')}
                                    >
                                        End Date {sortBy === 'endDate' && (sortOrder === 'asc' ? <ArrowUpward fontSize="inherit" /> : <ArrowDownward fontSize="inherit" />)}
                                    </th>

                                    <th
                                        className={styles.Head}
                                        style={{ ...cellStyle, color: theme.palette.sectionHeading.main, cursor: 'pointer', textAlign: 'center' }}
                                        onClick={() => handleSort('subType')}
                                    >
                                        Subscription Type {sortBy === 'subType' && (sortOrder === 'asc' ? <ArrowUpward fontSize="inherit" /> : <ArrowDownward fontSize="inherit" />)}
                                    </th>

                                    <th
                                        className={styles.Head}
                                        style={{ ...cellStyle, color: theme.palette.sectionHeading.main, cursor: 'pointer', textAlign: 'center' }}
                                        onClick={() => handleSort('noOfTests')}
                                    >
                                        Tests {sortBy === 'noOfTests' && (sortOrder === 'asc' ? <ArrowUpward fontSize="inherit" /> : <ArrowDownward fontSize="inherit" />)}
                                    </th>
                                    <th
                                        className={styles.Head}
                                        style={{ ...cellStyle, color: theme.palette.sectionHeading.main, cursor: 'pointer', textAlign: 'center' }}
                                        onClick={() => handleSort('RemainingTests')}
                                    >
                                        Remaining Tests {sortBy === 'RemainingTests' && (sortOrder === 'asc' ? <ArrowUpward fontSize="inherit" /> : <ArrowDownward fontSize="inherit" />)}
                                    </th>
                                    <th
                                        className={styles.Head}
                                        style={{ ...cellStyle, color: theme.palette.sectionHeading.main, cursor: 'pointer', textAlign: 'center' }}
                                        onClick={() => handleSort('amount')}
                                    >
                                        Amount (₹) {sortBy === 'amount' && (sortOrder === 'asc' ? <ArrowUpward fontSize="inherit" /> : <ArrowDownward fontSize="inherit" />)}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {paginatedData.length > 0 ? (
                                    paginatedData.map((tx, index) => (
                                        <tr key={index} style={index % 2 === 0 ? evenRowStyle : {}}>
                                            <td className={styles.codeColumn} style={{ ...cellStyle, textAlign: 'left' }}>{tx?.transactionId}</td>
                                            <td style={{ ...cellStyle, textAlign: 'left' }}>{convertToLocalTime(tx?.startDate)}</td>
                                            <td style={{ ...cellStyle, textAlign: 'left' }}>{convertToLocalTime(tx?.endDate)}</td>
                                            <td style={{ ...cellStyle, textAlign: 'center' }}>{tx?.subscriptionName}</td>
                                            <td style={{ ...cellStyle, textAlign: 'center' }}>{tx?.numberOfTests}</td>
                                            <td style={cellStyle}>
                                                {showSubscriptionData?.userSubscriptionId === tx?.userSubscriptionId ? Math.max(
                                                    transactions.reduce((sum, tx) => sum + (tx?.numberOfTests || 0), 0) -
                                                    transactions.reduce((sum, tx) => sum + (tx?.assignedTestsCount || 0), 0),
                                                    0
                                                ) : '-'}
                                            </td>
                                            <td style={{ ...cellStyle, textAlign: 'center', color: 'green', fontWeight: 600 }}>₹{tx?.price?.toFixed(2)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr className={styles.spanrow}>
                                        <td colSpan="5" style={{ textAlign: 'center' }}>
                                            <h5 style={{ marginTop: '15%', marginBottom: '15%' }}>No Transactions Found</h5>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                )
            }
            {/* MUI Pagination */}
            <Pagination
                count={Math.ceil(transactions.length / pageState.pageSize)}
                page={pageState.page}
                onChange={handleChange}
                sx={{
                    mt: 3,
                    display: 'flex',
                    justifyContent: 'right',
                    '& .MuiPaginationItem-root': {
                        color: '#1d2b69',
                    },
                    '& .MuiPaginationItem-root.Mui-selected': {
                        backgroundColor: '#1d2b69',
                        color: 'white',
                    },
                    '& .MuiPaginationItem-ellipsis': {
                        color: '#1d2b69',
                    },
                    '& .MuiPaginationItem-root:hover': {
                        backgroundColor: '#1d2b69',
                        color: 'white',
                    },
                }}
            />
        </div>
    );
};

export default TransactionPage;
